const windowHasLoaded = (async () => {
  if (typeof window === 'undefined') {
    return true;
  }
  // Gatsby's bundles are async scripts, so on a cached load the window's load
  // event has often fired before this module evaluates. A listener added then
  // never fires, and only the fallback timer below would resolve.
  if (document.readyState === 'complete') {
    return true;
  }
  const isLoaded = await (() => {
    const eventProm = new Promise<boolean>((resolve) => {
      window.addEventListener('load', () => {
        resolve(true);
      });
    });
    const timeOutProm = new Promise<boolean>((resolve) => {
      // Fallback for a load event that never arrives.
      setTimeout(() => {
        resolve(true);
      }, 3000);
    });
    return Promise.any([eventProm, timeOutProm]).then((d) => d);
  })();
  return isLoaded;
})();

let windowLoadedOverride: Promise<boolean> | null = null;

export const windowIsLoaded = async (): Promise<boolean> => {
  return windowLoadedOverride ?? windowHasLoaded;
};

// Test hook: replaces the load promise so a test controls when the window
// counts as loaded. Pass null to restore the real one.
export const __setWindowLoadedForTesting__ = (promise: Promise<boolean> | null): void => {
  windowLoadedOverride = promise;
};
